export default __webpack_public_path__ + "static/3_34-1fedee3afaaef5f0c125d1d0a972b3c3.png";